/**
 * DB'de /uploads/... tutulur; panel kendi REACT_APP_API_URL ile cozer.
 * Eski full URL'ler (domain degismis olsa bile) /uploads/ kismina indirgenir.
 */

const getApiUrl = () => {
  const base = process.env.REACT_APP_API_URL ?? 'http://localhost:3001';
  return base.replace(/\/$/, '');
};

/** Goruntu src'sini tarayicinin yukleyebilecegi absolute URL'ye cevir. */
export function resolveMediaUrl(src) {
  if (!src || typeof src !== 'string') return src;
  const trimmed = src.trim();
  if (!trimmed) return trimmed;

  if (
    trimmed.startsWith('data:') ||
    trimmed.startsWith('blob:') ||
    trimmed.startsWith('//')
  ) {
    return trimmed.startsWith('//') ? `https:${trimmed}` : trimmed;
  }

  // Eski kayit: https://eski-domain.com/uploads/x.jpg -> mevcut API ile servis
  const uploadsIdx = trimmed.indexOf('/uploads/');
  if (uploadsIdx !== -1) {
    return `${getApiUrl()}${trimmed.slice(uploadsIdx)}`;
  }

  if (trimmed.startsWith('http://') || trimmed.startsWith('https://')) {
    return trimmed;
  }

  return `${getApiUrl()}${trimmed.startsWith('/') ? '' : '/'}${trimmed}`;
}

/** DB'ye yazarken full upload URL'lerini relative /uploads/... yap. blob/data asla kalmaz. */
export function toRelativeMediaSrc(src) {
  if (!src || typeof src !== 'string') return src;
  const trimmed = src.trim();
  if (!trimmed) return trimmed;
  if (trimmed.startsWith('blob:') || trimmed.startsWith('data:')) {
    return null;
  }

  const uploadsIdx = trimmed.indexOf('/uploads/');
  if (uploadsIdx !== -1) {
    return trimmed.slice(uploadsIdx);
  }
  return trimmed;
}

/** Date / Blob / File gibi special object'leri plain object sanma. */
const isPlainObject = (value) =>
  value != null &&
  typeof value === 'object' &&
  !(value instanceof Date) &&
  !(value instanceof Blob) &&
  !(value instanceof File) &&
  !Array.isArray(value);

/** Nested kayitlarda { src } alanlarini relative'e cevir (kayit oncesi). */
export function stripMediaUrlsDeep(value) {
  if (Array.isArray(value)) {
    return value.map((item) => stripMediaUrlsDeep(item));
  }
  if (isPlainObject(value)) {
    const out = {};
    for (const [key, val] of Object.entries(value)) {
      // File / blob kalintisi DB'ye gitmesin
      if (key === 'rawFile') continue;
      if (key === 'src' && typeof val === 'string') {
        const relative = toRelativeMediaSrc(val);
        if (relative == null) continue;
        out[key] = relative;
      } else {
        out[key] = stripMediaUrlsDeep(val);
      }
    }
    // src'siz / bozulmus image objesini tamamen at
    if (
      Object.prototype.hasOwnProperty.call(value, 'src') &&
      out.src == null &&
      (value.rawFile != null ||
        (typeof value.src === 'string' &&
          (value.src.startsWith('blob:') || value.src.startsWith('data:'))))
    ) {
      return null;
    }
    return out;
  }
  return value;
}

/** Nested kayitlarda { src } alanlarini absolute yap (panel ImageField icin). */
export function expandMediaUrlsDeep(value) {
  if (Array.isArray(value)) {
    return value.map((item) => expandMediaUrlsDeep(item));
  }
  if (isPlainObject(value)) {
    const out = {};
    for (const [key, val] of Object.entries(value)) {
      if (key === 'src' && typeof val === 'string') {
        out[key] = resolveMediaUrl(val);
      } else {
        out[key] = expandMediaUrlsDeep(val);
      }
    }
    return out;
  }
  return value;
}
